import { UserProfile } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useAppNavigation } from "@hooks/navigation/use-app-navigation";
import { useNavigate } from "react-router-dom";
import { useUserContext } from "@pages/account-settings/user-provider";
import { BrowserUtils } from "@stellar/utils";
import { useAppSelector } from "@store/store-helper";
import { isUserLoggedInSelector } from "@store/user/user-selector";

/** Custom hook returning the account settings close handler */
export function useCloseAccountSettings(): { onCloseButtonClick(): void } {
  const { trackEvent } = useTrackEvent();
  const navigate = useNavigate();
  const { navigateToRoot } = useAppNavigation();
  const { originUrl } = useUserContext();
  const isUserLoggedIn = useAppSelector(isUserLoggedInSelector);

  /**
   * Clicking on close will navigate to the origin URL from where the user opened the account settings page.
   * If the original URL is not available then clicking on close will navigate to the root route.
   */
  function onCloseButtonClick(): void {
    trackEvent({
      name: UserProfile.closeAccount,
      props: {
        isUserLoggedIn,
      },
    });

    // Check if the account setting page is in iframe
    if (BrowserUtils.isInIframe()) {
      const message = {
        action: "closeSettingPage",
      };

      window.parent.postMessage(message, "*");
      return;
    }

    if (originUrl) {
      navigate(originUrl);
    } else {
      navigateToRoot();
    }
  }

  return { onCloseButtonClick };
}
